import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class BankStatementUploadApiService {
  controllerUrl: string = 'bankstatementuploads';

  constructor(private readonly httpClient: HttpClient) { }

  create(companyName: string, apiKey: Guid): Observable<Guid> {
    const headers = new HttpHeaders({ 'apiKey': apiKey.toString() });
    return this.httpClient.post<Guid>(`${environment.dataApiUrl}/${this.controllerUrl}/create`, { companyName }, { headers });
  }

  getUploadUrl(): string {
    return `${environment.dataApiUrl}/${this.controllerUrl}/upload`;
  }
}
